import React from 'react';

/** Muestra teléfono de contacto con ícono; no renderiza si está vacío */
const ContactPhoneRow: React.FC<{
    phone?: string | number | null;
    label?: string;
    className?: string;
}> = ({ phone, label = 'Teléfono de contacto', className = '' }) => {
    const t = phone != null ? String(phone).trim() : '';
    if (!t) return null;
    return (
        <div className={className}>
            <strong className="block text-gray-500">{label}</strong>
            <div className="flex items-center gap-2 mt-0.5 text-gray-800">
                <svg
                    className="w-4 h-4 shrink-0 text-gray-600"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    aria-hidden
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                    />
                </svg>
                <span className="break-all">{t}</span>
            </div>
        </div>
    );
};

export default ContactPhoneRow;
